import {connect} from 'react-redux';
import {getResources} from 'redux-resource';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import {readLanguages} from '../redux/actions/languages';

function mapStateToProps(state) {
	const languages = getResources(state.languages, 'all');

	return {languages};
}

function mapDispatchToProps(dispatch) {
	return {
		readLanguages() {
			dispatch(readLanguages());
		}
	};
}

export default compose(
	connect(mapStateToProps, mapDispatchToProps),
	lifecycle({
		componentDidMount() {
			this.props.readLanguages();
		}
	}),
	branch(
		props => !props.languages,
		renderNothing
	)
);



// WEBPACK FOOTER //
// ./src/client/routes/with-fetch-languages.js